/**
 * Checks the error type from API.
 *
 * @param apiErrorTypes type of error returned by API.
 * @param status status code returned by API.
 *
 */
export function getSkillsErrorType(apiErrorTypes, status: number) {
  const errorTypes = {
    404: apiErrorTypes.NotFoundError,
    422: apiErrorTypes.RequestValidationError,
  };

  return errorTypes[status] || apiErrorTypes.ServiceUnavailableError;
}
